import { activationFunctions } from "./activation.js"

class Perceptron {
  constructor(weights, params = {}) {
    const defaults = {
      activation: activationFunctions.sigmoid,
      bias: 0
    }
    params = {...defaults, ...params}
    
    this.activation = params.activation
    this.weights = weights
    this.bias = params.bias
  }

  evaluate(inputs, params) {
    const defaults = {
      verbose: false,
    }
    params = { ...defaults, ...params }

    if(inputs.length != this.weights.length) {
      console.log(`inputs ${inputs}`)
      console.log(`weights: ${this.weights}`)
      throw new Error('Weights and inputs must be same length')
    }
    else {
      var z = 0

      for(let i = 0; i < inputs.length; i++) {
        // add each input to sum according to weights
        z += inputs[i] * this.weights[i]
      }

      // add bias
      z = z + this.bias

      // apply activation function
      const a = this.activation(z)
  
      if(params.verbose) {
        return {
          activation: a,
          z: z,
          bias: this.bias,
          weights: this.weights
        }
      }
      else {
        return a
      }
      
    }
  }

  // import from serializable object
  static load(data) {
    return new Perceptron(data.weights, {
      activation: activationFunctions[data.activation],
      bias: data.bias
    })
  }

  // export to serializable object
  dump() {
    return {
      activation: this.activation.fname,
      weights: this.weights,
      bias: this.bias
    }
  }
}

export {
  Perceptron
}